module.exports = __webpack_public_path__ + "img/blog-9.4a2acef7.jpg";